jQuery(function($){

	favoriteFlats();
	blockSlider();
	rwdMenu();
    inifFancybox();
	goTo();
	showMobileMore();
	initSortableTables();
	flatsPopup();
	flatsViewToggle();
	parkingSort();
	askForm();
	singleFlatDescriptionMore();

	function singleFlatDescriptionMore() {
		$(document).on('click', '.single-flat__description__more-btn', function(event) {
			event.preventDefault();

			const $button = $(this);
			const $wrapper = $button.closest('.single-flat__description');
			const $more = $wrapper.find('.single-flat__description__more').first();
			const isLessButton = $button.hasClass('single-flat__description__less-btn');

			if (isLessButton) {
				$more.slideUp(300);
				$wrapper.removeClass('active');
			} else {
				$more.slideDown(300);
				$wrapper.addClass('active');
			}
		});
	}

	function favoriteFlats() {
		const COOKIE_NAME = 'favorite_flats';
		const COOKIE_DAYS = 7;
		const STORAGE_NAME = 'favorite_flats';

		window.kiviFavoriteFlatsReady = true;

		function getCookie(name) {
			const value = document.cookie
				.split('; ')
				.find(row => row.indexOf(name + '=') === 0);

			if (!value) {
				return [];
			}

			try {
				const parsed = JSON.parse(decodeURIComponent(value.split('=')[1]));
				return Array.isArray(parsed) ? parsed : [];
			} catch (error) {
				return [];
			}
		}

		function getStoredFavorites() {
			try {
				const parsed = JSON.parse(localStorage.getItem(STORAGE_NAME) || '[]');
				return Array.isArray(parsed) ? parsed : [];
			} catch (error) {
				return [];
			}
		}

		function getFavorites() {
			const favorites = getCookie(COOKIE_NAME).concat(getStoredFavorites());

			return favorites
				.map(String)
				.filter(function (id, index, items) {
					return id && items.indexOf(id) === index;
				});
		}

		function setCookie(name, value, days) {
			const expires = new Date();

			expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
			document.cookie = name + '=' + encodeURIComponent(JSON.stringify(value)) + '; expires=' + expires.toUTCString() + '; path=/';
		}

		function setFavorites(value) {
			const favorites = value
				.map(String)
				.filter(function (id, index, items) {
					return id && items.indexOf(id) === index;
				});

			try {
				localStorage.setItem(STORAGE_NAME, JSON.stringify(favorites));
			} catch (error) {}

			setCookie(COOKIE_NAME, favorites, COOKIE_DAYS);
			syncFavoritesCookie(favorites);

			return favorites;
		}

		function syncFavoritesCookie(favorites) {
			if (typeof WLC === 'undefined' || !WLC.ajaxurl) {
				return;
			}

			$.ajax({
				url: WLC.ajaxurl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'kivi_save_favorite_flats',
					ids: favorites
				}
			});
		}

		function refreshFavoriteButtons() {
			const favorites = getFavorites();

			$('.add-to-favorites').each(function () {
				const postId = String($(this).data('post-id') || '');

				if (!postId) {
					return;
				}

				$(this).toggleClass('added', favorites.indexOf(postId) !== -1);
			});
		}

		function refreshFavoritesCounter() {
			const count = getFavorites().length;
			const $counter = $('.favorites-count');

			if (count > 0) {
				if ($counter.length) {
					$counter.text(count);
				} else {
					$('.site-header__buttons a:last-child').append('<span class="favorites-count">' + count + '</span>');
				}
			} else {
				$counter.remove();
			}
		}

		function refreshFavoritesState() {
			refreshFavoriteButtons();
			refreshFavoritesCounter();
			refreshHeaderFavoritesState();
		}

		function isMobileFavoritesHeader() {
			return window.innerWidth < 1025;
		}

		function refreshHeaderFavoritesState() {
			const favorites = getFavorites();
			const $wrapper = $('.site-header__favourites-wrapper');

			if (!$wrapper.length) {
				return;
			}

			$wrapper.toggleClass('has-favourites', favorites.length > 0);
			$wrapper.find('.site-header__favourites').toggleClass('has-favourites', favorites.length > 0);

			if (!favorites.length) {
				$wrapper.removeClass('is-open');
				$wrapper.find('.site-header__favourites-dropdown').empty();
			}
		}

		function refreshHeaderFavoritesDropdown() {
			const favorites = getFavorites();
			const $wrapper = $('.site-header__favourites-wrapper');

			if (!$wrapper.length) {
				return;
			}

			const $dropdown = $wrapper.find('.site-header__favourites-dropdown');

			refreshHeaderFavoritesState();

			if (!favorites.length) {
				$dropdown.empty();
				return;
			}

			if (typeof WLC === 'undefined' || !WLC.ajaxurl) {
				return;
			}

			$.ajax({
				url: WLC.ajaxurl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'kivi_get_header_favorite_flats',
					ids: favorites
				},
				success: function(response) {
					if (!response || !response.success || !response.data) {
						$dropdown.empty();
						refreshHeaderFavoritesState();
						return;
					}

					$dropdown.html(response.data.html);
					$wrapper.toggleClass('has-favourites', response.data.count > 0);
					$wrapper.find('.site-header__favourites').toggleClass('has-favourites', response.data.count > 0);
				},
				error: function() {
					$dropdown.empty();
				}
			});
		}

		function refreshFavoritesPage() {
			const $favorites = $('.favorite-flats');

			if (!$favorites.length) {
				return;
			}

			const favorites = getFavorites();
			const $tbody = $favorites.find('.favorite-flats__list');
			const $tiles = $favorites.find('.favorite-flats__tiles');
			const $count = $favorites.find('.favorite-flats__count strong');
			const $delete = $favorites.find('.favorite-flats__delete');
			const $download = $favorites.find('.favorite-flats__download');
			$download.prop('disabled', true);
			const $popups = $('.favorite-flats__popups');

			function renderEmpty() {
				$tbody.html('<tr class="favorite-flats__empty"><td colspan="14">Nie dodałeś jeszcze żadnego mieszkania do ulubionych.</td></tr>');
				$tiles.html('<div class="flats__tiles-empty">Nie dodałeś jeszcze żadnego mieszkania do ulubionych.</div>');
				$count.text('0');
				$delete.hide();
				$popups.empty();
			}

			if (!favorites.length) {
				renderEmpty();
				return;
			}

			if (typeof WLC === 'undefined' || !WLC.ajaxurl) {
				return;
			}

			$.ajax({
				url: WLC.ajaxurl,
				type: 'POST',
				dataType: 'json',
				data: {
					action: 'kivi_get_favorite_flats',
					ids: favorites
				},
				success: function(response) {
					if (!response || !response.success || !response.data) {
						renderEmpty();
						return;
					}

					$tbody.html(response.data.rows);
					$tiles.html(response.data.tiles);
					$count.text(response.data.count);
					$download.prop('disabled', response.data.count === 0);
					$popups.html(response.data.popups);

					if (response.data.count > 0) {
						$delete.show();
					} else {
						$delete.hide();
					}

					refreshFavoritesState();
					initSortableTables($favorites);
				},
				error: renderEmpty
			});
		}

		$(document).on('click', '.favorite-flats__download', async function () {
			const button = this;
			const status = button.parentElement.querySelector('.favorite-flats__download-status');
			const ids = getFavorites();
			if (!ids.length || button.dataset.busy) return;
			button.dataset.busy = '1';
			button.disabled = true;
			status.textContent = 'Generowanie PDF…';
			const data = new URLSearchParams({ action: 'kivi_download_favorites_pdf', nonce: button.dataset.nonce });
			ids.forEach(id => data.append('ids[]', id));
			try {
				const imageRequest = new URLSearchParams(data);
				imageRequest.set('action', 'kivi_favorites_pdf_images');
				const metadata = await fetch(button.dataset.url, { method: 'POST', body: imageRequest, credentials: 'same-origin' });
				const imageData = await metadata.json();
				if (!metadata.ok || !imageData.success) throw new Error('Odśwież stronę i spróbuj ponownie.');
				const images = {};
				for (const [id, fields] of Object.entries(imageData.data || {})) {
					images[id] = {};
					for (const [key, path] of Object.entries(fields)) {
						const source = await fetch(path, { credentials: 'same-origin' });
						if (!source.ok) throw new Error('Nie udało się pobrać rzutu mieszkania. Spróbuj ponownie.');
						const url = URL.createObjectURL(await source.blob());
						try {
							const image = new Image();
							image.src = url;
							await image.decode();
							const scale = (key === 'thumbnail' ? 1400 : 700) / Math.max(image.naturalWidth, image.naturalHeight);
							const canvas = document.createElement('canvas');
							canvas.width = Math.round(image.naturalWidth * scale);
							canvas.height = Math.round(image.naturalHeight * scale);
							const context = canvas.getContext('2d');
							context.fillStyle = '#fff';
							context.fillRect(0, 0, canvas.width, canvas.height);
							context.drawImage(image, 0, 0, canvas.width, canvas.height);
							images[id][key] = canvas.toDataURL('image/jpeg', 0.85);
						} finally { URL.revokeObjectURL(url); }
					}
				}
				data.set('images', JSON.stringify(images));
				const response = await fetch(button.dataset.url, { method: 'POST', body: data, credentials: 'same-origin' });
				if (!response.ok || !(response.headers.get('content-type') || '').includes('application/pdf')) {
					throw new Error('Nie udało się pobrać PDF. Odśwież stronę i spróbuj ponownie.');
				}
				const url = URL.createObjectURL(await response.blob());
				const link = document.createElement('a');
				link.href = url;
				link.download = 'ulubione-mieszkania.pdf';
				document.body.appendChild(link);
				link.click();
				link.remove();
				setTimeout(() => URL.revokeObjectURL(url), 60000);
				status.textContent = 'PDF został pobrany.';
			} catch (error) {
				status.textContent = error.message;
			} finally {
				delete button.dataset.busy;
				button.disabled = !getFavorites().length;
			}
		});

		refreshFavoritesState();
		refreshFavoritesPage();
		refreshHeaderFavoritesDropdown();

		$(window).on('load', refreshFavoritesState);

		$(window).on('resize', function() {
			if (!isMobileFavoritesHeader()) {
				$('.site-header__favourites-wrapper').removeClass('is-open');
			}
		});

		$(document).on('click', '.site-header__favourites', function(event) {
			if (!isMobileFavoritesHeader()) {
				return;
			}

			event.preventDefault();

			const $wrapper = $(this).closest('.site-header__favourites-wrapper');

			if (!$wrapper.hasClass('has-favourites')) {
				return;
			}

			$wrapper.toggleClass('is-open');
			refreshHeaderFavoritesDropdown();
		});

		$(document).on('click', function(event) {
			if (!isMobileFavoritesHeader()) {
				return;
			}

			if ($(event.target).closest('.site-header__favourites-wrapper').length) {
				return;
			}

			$('.site-header__favourites-wrapper').removeClass('is-open');
		});

		$(document).on('click', '.add-to-favorites', function (event) {
			event.preventDefault();

			const $button = $(this);
			const postId = String($button.data('post-id') || '');

			if (!postId) {
				return;
			}

			let favorites = getFavorites();

			if (favorites.indexOf(postId) !== -1) {
				favorites = favorites.filter(id => id !== postId);
			} else {
				favorites.push(postId);
			}

			setFavorites(favorites);
			refreshFavoritesState();
			refreshFavoritesPage();
			refreshHeaderFavoritesDropdown();
		});

		$(document).on('click', '.remove-favorite-flat', function (event) {
			event.preventDefault();

			const postId = String($(this).data('post-id') || '');
			const $headerWrapper = $('.site-header__favourites-wrapper');
			const $headerDropdown = $headerWrapper.find('.site-header__favourites-dropdown');
			let favorites = getFavorites();

			favorites = favorites.filter(id => id !== postId);
			setFavorites(favorites);

			$('.favorite-flat[data-post-id="' + postId + '"]').remove();
			$('.site-header__favourites-item[data-post-id="' + postId + '"]').remove();

			if (!favorites.length) {
				$headerDropdown.empty();
				$headerWrapper.removeClass('has-favourites');
				$headerWrapper.find('.site-header__favourites').removeClass('has-favourites');
			}

			refreshFavoritesState();
			refreshFavoritesPage();
			refreshHeaderFavoritesDropdown();
		});

		$(document).on('click', '.delete-all-favorites', function (event) {
			event.preventDefault();

			document.cookie = COOKIE_NAME + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC; SameSite=Lax';
			try {
				localStorage.removeItem(STORAGE_NAME);
			} catch (error) {}
			syncFavoritesCookie([]);
			refreshFavoritesState();

			if ($('.favorite-flats').length) {
				refreshFavoritesPage();
			} else {
				refreshFavoritesState();
			}

			refreshHeaderFavoritesDropdown();
		});

		$(document).ajaxComplete(refreshFavoritesState);
	}

	function parkingSort() {
		const $parking = $('.parking');

		if (!$parking.length) {
			return;
		}

		$(document).on('change', '#parking-sort-select', function() {
			const selectedBuilding = $(this).val();
			const $section = $(this).closest('.parking');
			const $items = $section.find('.parking__list article');

			if (!selectedBuilding) {
				$items.show();
				return;
			}

			$items.each(function() {
				const $item = $(this);
				const buildings = ($item.data('parking-building') || '').toString().split(' ');

				$item.toggle(buildings.indexOf(selectedBuilding) !== -1);
			});
		});
	}

	function askForm() {
		function setFlat($container, title) {
			$container.find('input[name="flat"]').each(function () {
				this.value = title;
				this.defaultValue = title;
			});
		}

		const $singleFlat = $('.single-flat .ask-form[data-flat]').first();
		if ($singleFlat.length) {
			setFlat($('#kontakt, .flat-contact-form'), $singleFlat.attr('data-flat'));
		}

		$(document).on('click', '.ask-form', function(event) {
			event.preventDefault();
			const $contact = $('#kontakt');
			const title = $(this).attr('data-flat') || '';
			setFlat($contact, title);
			$contact.find('textarea').val($(this).attr('data-txt') || '');
			if ($contact.length) {
				$('html, body').animate({
					scrollTop: $contact.offset().top - 70
				}, 500);
			}
		});
	}

	function flatsPopup() {
		$(document).on('click', '.close-popup', function(event) {
			event.preventDefault();
			const $popup = $(this).closest('.popup');
			$popup.removeClass('active');
			$popup.find('.popup__wrapper').hide();
		});

		$(document).on('click', '.show-price-history', function(event) {
			event.preventDefault();
			const href = $(this).attr('href') || '';
			const $wrappers = $('.popup__wrapper').filter(function() {
				return href === '#' + this.id;
			});

			if (!$wrappers.length) {
				return;
			}

			$('.popup').removeClass('active');
			$('.popup__wrapper').hide();
			$wrappers.show().closest('.popup').addClass('active');
		});
	}

	function flatsViewToggle() {
		const $flats = $('.flats');

		if (!$flats.length) {
			return;
		}

		function setView($section, view) {
			const selectedView = view === 'tiles' ? 'tiles' : 'list';

			$section.find('[data-flats-panel]').hide();
			$section.find('[data-flats-panel="' + selectedView + '"]').show();
			$section.find('[data-flats-view]').removeClass('active');
			$section.find('[data-flats-view="' + selectedView + '"]').addClass('active');
		}

		$flats.each(function () {
			const $section = $(this);
			const initialView = window.location.hash === '#tiles' ? 'tiles' : 'list';

			setView($section, initialView);
		});

		$(document).on('click', '[data-flats-view]', function (event) {
			event.preventDefault();

			const $button = $(this);
			const view = $button.data('flats-view');
			const $section = $button.closest('.flats');

			setView($section, view);

			if (window.history && window.history.replaceState) {
				window.history.replaceState(null, '', '#' + view);
			}
		});
	}

	function showMobileMore() {
		$(document).on('click', '.show-mobile-more', function(event) {
			event.preventDefault();

			const $button = $(this);
			const $row = $button.closest('tr');
			const $parent = $button.parent('td').parent('tr');
			const $moreRow = $row.next('.tr-mobile-more');

			$moreRow.slideToggle(300);
			$button.toggleClass('active');
			$parent.toggleClass('active');
		});
	}

    function initSortableTables(context) {
		const $context = context ? $(context) : $(document);
		const $tables = $context
			.find('.flats__list table, .areas__wrapper table')
			.add($context.filter('.flats__list table, .areas__wrapper table'));

		if (!$.fn.stupidtable) {
			return;
		}

		$tables.each(function () {
			const $table = $(this);

			prepareSortableDetailRows($table);

			if (!$table.data('kivi-sortable-ready')) {
				detachSortableDetailRows($table);

				$table
					.on('beforetablesort.kivi', function () {
						$(this).find('thead th').removeClass('kivi-sort-default');
						detachSortableDetailRows($(this));
					})
					.on('aftertablesort.kivi', function () {
						restoreSortableDetailRows($(this));
					})
					.stupidtable();

				$table.off('click.stupidtable', 'thead th');
				$table.find('thead th[data-sort]')
					.off('click.kivi-sortable')
					.on('click.kivi-sortable', function (event) {
						event.preventDefault();
						$(this).stupidsort();
					});

				restoreSortableDetailRows($table);
				$table.data('kivi-sortable-ready', true);
				$table.attr('data-sortable-ready', 'true');
			} else {
				detachSortableDetailRows($table);
				$table.stupidtable_build();
				restoreSortableDetailRows($table);
			}
			const $headers = $table.find('thead th[data-sort]');
			if (!$headers.filter('.sorting-asc, .sorting-desc').length) {
				$headers.filter('[data-sort-initial="true"]').first()
					.addClass('kivi-sort-default sorting-asc')
					.data('sort-dir', $.fn.stupidtable.dir.ASC);
			}
		});
	}

	function prepareSortableDetailRows($table) {
		$table.find('tbody tr.tr-mobile-more').each(function () {
			const $detailRow = $(this);
			const $mainRow = $detailRow.prev('tr:not(.tr-mobile-more)');

			if ($mainRow.length) {
				$mainRow.data('sort-detail-row', $detailRow);
			}
		});
	}

	function detachSortableDetailRows($table) {
		prepareSortableDetailRows($table);
		$table.find('tbody tr.tr-mobile-more').detach();
	}

	function restoreSortableDetailRows($table) {
		$table.find('tbody tr:not(.tr-mobile-more)').each(function () {
			const $detailRow = $(this).data('sort-detail-row');

			if ($detailRow && $detailRow.length) {
				$detailRow.insertAfter(this);
			}
		});
	}
	function goTo() {

    $(".go-to").click(function(event) {
        event.preventDefault();
        var href = $(this).attr('href');
        var pos = -100;
        jQuery('html, body').animate({
            scrollTop: jQuery(href).offset().top + pos
        }, 500);
        });
    }

    function inifFancybox() {
		if (typeof Fancybox === 'undefined') {
			return;
		}

        Fancybox.bind('[data-fancybox]', {
        Thumbs: false,
        loop : true,
        on: {
            'Carousel.initSlide': function(fancybox, carousel, slide) {
                var trigger = slide && slide.triggerEl ? slide.triggerEl : null;

                if (!trigger || !trigger.classList.contains('flat-svg-lightbox') || window.innerWidth <= 1024) {
                    return;
                }

                var thumb = trigger.querySelector('img');
                var ratio = thumb && thumb.naturalWidth && thumb.naturalHeight ? thumb.naturalHeight / thumb.naturalWidth : 0.6667;

                slide.width = 900;
                slide.height = Math.round(900 * ratio);
                slide.class = ((slide.class || '') + ' flat-svg-lightbox-slide').trim();
            }
        },

        afterClose: function(instance, current) {
            var videos = document.querySelectorAll('.inline-movies');

            videos.forEach(function(video) {
                video.pause();
            });
        }
        });
    }
    
	function rwdMenu() {
		var windowWidth = $(document).width();

		$('#hamburger').click(function(event) {
			event.preventDefault();
			$(this).toggleClass('open');
			$('.site-header__navigation > ul').slideToggle(500);
			$('.site-header').toggleClass('menu-opened');
		});

		if (windowWidth < 1024) {

			$('.site-header__navigation .menu-item-has-children > a').on('click', function(event) {
				event.stopPropagation();
				$(this).parent('li').children('ul').slideToggle(300);
				$(this).parent('li').toggleClass('active');
			});
			
			$('.menu-item-has-children').on('click', function(event) {
				if (!$(event.target).is('a')) {
					event.stopPropagation();
					$(this).children('ul').slideToggle(300);
					$(this).toggleClass('active');
				}
			});
		}
	}

	(function () {
		var previousScroll = 0;
		
		$(window).scroll(function () {

			   var currentScroll = $(this).scrollTop();

			   if (currentScroll > 10) {
				   if (currentScroll > previousScroll){
					   $('header').addClass('fixed');
				   }
				   else {
					  $('header').removeClass('fixed');
				   }
				   previousScroll = currentScroll;

			   } else {
					   $('header').removeClass('fixed');
					$('header').removeClass('fixed');
			   }
	    });
	}());

    $(window).scroll(function() {   
        var windowWidth = $(window).width();
        var scroll = $(window).scrollTop();

        if (scroll >= 100 ) {
            $("header").addClass("scrolled");
        
        } else {
            $("header").removeClass("scrolled");
        }

    });

	function blockSlider() {

		jQuery('.home-slider').owlCarousel({
            animateOut: 'fadeOut',
            animateIn: 'fadeIn',
			loop:true,
			margin:0,
			nav:false,
			items:1,
			autoplay:true,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: true,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,
			singleItem: true,
			navText: ['<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M47.5 44C47.5 45.933 45.933 47.5 44 47.5L2 47.5C1.17157 47.5 0.5 46.8284 0.5 46L0.500004 2C0.500004 1.17157 1.17158 0.499996 2 0.499996L44 0.5C45.933 0.5 47.5 2.06701 47.5 4L47.5 44Z" stroke="white"/><path d="M28.666 24L19.3327 24" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 28.666L19.3333 23.9993L24 19.3327" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.5 4C0.5 2.067 2.067 0.5 4 0.5H46C46.8284 0.5 47.5 1.17157 47.5 2V46C47.5 46.8284 46.8284 47.5 46 47.5H4C2.067 47.5 0.5 45.933 0.5 44V4Z" stroke="white"/><path d="M19.334 24H28.6673" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 19.334L28.6667 24.0007L24 28.6673" stroke="#F0E000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
			autoplayHoverPause:true
		});

		jQuery('.stages-slider').owlCarousel({
			loop:false,
			margin:0,
			nav:true,
			items:1,
			autoplay:false,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: false,
            mouseDrag: false,
            touchDrag: false,
            pullDrag: false,
            freeDrag: false,
			singleItem: true,
			navText: ['<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">  <circle cx="30" cy="30" r="30" transform="rotate(-180 30 30)" fill="#C90C0F"/><path d="M23.8711 26.3628L20.1211 30.0564L23.8711 33.75M20.1211 30.0564L38.1211 30.0564" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="30" fill="#C90C0F"/><path d="M36.1289 33.6958L39.8789 30.0022L36.1289 26.3086M39.8789 30.0022H21.8789" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
            autoplayHoverPause:true,
			onChanged: function(event) {
				const $stage = jQuery(event.target).closest('.stages');
				const currentIndex = event.item ? event.item.index : 0;

				$stage.find('.stages-dots .owl-dot').removeClass('active');
				$stage.find('.stages-dots .owl-dot[data-stage-slide="' + currentIndex + '"]').addClass('active');
			}
		});

		jQuery(document).on('click', '.stages .owl-dot', function(event) {
			event.preventDefault();

			const $dot = jQuery(this);
			const dotIndex = $dot.data('stage-slide');
			const $slider = $dot.closest('.stages').find('.stages-slider');

			if ($dot.hasClass('inactive') || typeof dotIndex === 'undefined') {
				return;
			}

			$slider.trigger('to.owl.carousel', [dotIndex, 500, true]);
		});

        jQuery('.partners-slider').owlCarousel({
            loop:true,
            margin:32,
            nav:true,
            items:1,
            autoplay:true,
            autoplayTimeout:4000,
            autoplaySpeed: 1700,
            slideSpeed: 1700,
            navSpeed: 1700,
            dotsSpeed: 1700,
            dots: false,
            singleItem: true,
            stagePadding: 100,
            navText: ['<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M48 44C48 46.2091 46.2091 48 44 48L2 48C0.895432 48 7.8281e-08 47.1046 1.74846e-07 46L4.02145e-06 2C4.11801e-06 0.895427 0.895436 -4.11801e-06 2 -4.02145e-06L44 -3.49691e-07C46.2091 -1.56562e-07 48 1.79086 48 4L48 44Z" fill="#F6F6FB"/><path d="M28.666 24L19.3327 24" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 28.667L19.3333 24.0003L24 19.3337" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 4C0 1.79086 1.79086 0 4 0H46C47.1046 0 48 0.895431 48 2V46C48 47.1046 47.1046 48 46 48H4C1.79086 48 0 46.2091 0 44V4Z" fill="#F6F6FB"/><path d="M19.334 24H28.6673" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M24 19.333L28.6667 23.9997L24 28.6663" stroke="#21212C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
            autoplayHoverPause:true,
            responsive:{
                0:{
                items:1,
                },
                960:{
                items:2,
                },
                1100:{
                items:3,
                },
                1240:{
                items:4,
                },
                1440:{
                    items:5,
                },
                1900:{
                    items:6,
                },
                
            }
        });

		function initDiarySlider($slider) {
			if (!$slider.length || $slider.data('diary-slider-ready')) {
				return;
			}

			const slideCount = $slider.find('.diary-slider__item').length;
			const hasMultipleSlides = slideCount > 1;
			const lastSlideIndex = Math.max(slideCount - 1, 0);

			$slider.owlCarousel({
			loop:hasMultipleSlides,
			margin:0,
			nav:hasMultipleSlides,
			items:1,
			autoplay:hasMultipleSlides,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: false,
			singleItem: true,
				startPosition: lastSlideIndex,
			navText: ['<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">  <circle cx="30" cy="30" r="30" transform="rotate(-180 30 30)" fill="#C90C0F"/><path d="M23.8711 26.3628L20.1211 30.0564L23.8711 33.75M20.1211 30.0564L38.1211 30.0564" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="30" fill="#C90C0F"/><path d="M36.1289 33.6958L39.8789 30.0022L36.1289 26.3086M39.8789 30.0022H21.8789" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
            autoplayHoverPause:true,
            responsive:{
                0:{
                
                stagePadding: 50,
                items:1,
                },
                960:{
                items:1,
                stagePadding: 80,
                },
                1440:{
                    items:1,
                    stagePadding: 180,
                },
                1900:{
                    items:1,
                    stagePadding: 350,
                },
                
            },
				onInitialized: function(event) {
					updateDiaryDots(event);
				},
				onChanged: function(event) {
					updateDiaryDots(event);
				}
			});

			$slider.data('diary-slider-ready', true);
		}

		function updateDiaryDots(event) {
			const $stage = jQuery(event.target).closest('.diary__stage');
			const currentIndex = event.relatedTarget && event.item ? event.relatedTarget.relative(event.item.index) : 0;

			$stage.find('.diary-dots .owl-dot').removeClass('active');
			$stage.find('.diary-dots .owl-dot[data-diary-slide="' + currentIndex + '"]').addClass('active');
		}

		jQuery('.diary__stage.opened .diary-slider').each(function() {
			initDiarySlider(jQuery(this));
		});

		jQuery(document).on('click', '.diary nav a.active', function(event) {
			event.preventDefault();

			const $link = jQuery(this);
			const target = $link.attr('href');
			const $diary = $link.closest('.diary');
			const $stage = $diary.find(target);

			if (!$stage.length || $link.hasClass('opened')) {
				return;
			}

			$diary.find('nav a').removeClass('opened');
			$link.addClass('opened');
			$diary.find('.diary__stage').removeClass('opened');
			$stage.addClass('opened');

			const $slider = $stage.find('.diary-slider');
			initDiarySlider($slider);
			$slider.trigger('refresh.owl.carousel');
		});

		jQuery(document).on('click', '.diary .diary-dots .owl-dot', function(event) {
			event.preventDefault();

			const $dot = jQuery(this);
			const slideIndex = $dot.data('diary-slide');
			const $slider = $dot.closest('.diary__stage').find('.diary-slider');

			if (typeof slideIndex === 'undefined') {
				return;
			}

			$slider.trigger('to.owl.carousel', [slideIndex, 500, true]);
		});

        jQuery('.gallery-slider').owlCarousel({
			loop:true,
			margin:0,
			nav:true,
			items:1,
			autoplay:true,
			autoplayTimeout:4000,
			autoplaySpeed: 1700,
			slideSpeed: 1700,
			navSpeed: 1700,
			dotsSpeed: 1700,
			dots: false,
			singleItem: true,
			navText: ['<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">  <circle cx="30" cy="30" r="30" transform="rotate(-180 30 30)" fill="#C90C0F"/><path d="M23.8711 26.3628L20.1211 30.0564L23.8711 33.75M20.1211 30.0564L38.1211 30.0564" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>','<svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="30" cy="30" r="30" fill="#C90C0F"/><path d="M36.1289 33.6958L39.8789 30.0022L36.1289 26.3086M39.8789 30.0022H21.8789" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>'],
            autoplayHoverPause:true,
            responsive:{
                0:{
                
                stagePadding: 50,
                items:1,
                },
                960:{
                items:1,
                stagePadding: 80,
                },
                1440:{
                    items:1,
                    stagePadding: 180,
                },
                1900:{
                    items:1,
                    stagePadding: 350,
                },
                
            }
		  });
    }

})
